import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03534a61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-4" }, "Browser Details", -1))
const _hoisted_3 = { class: "table-auto w-full border-collapse border border-gray-400" }
const _hoisted_4 = { class: "odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }, "Browser", -1))
const _hoisted_6 = { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }
const _hoisted_7 = { class: "odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }, "Operating System", -1))
const _hoisted_9 = { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }
const _hoisted_10 = { class: "odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }, "Device", -1))
const _hoisted_12 = { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }
const _hoisted_13 = { class: "odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }, "User Agent", -1))
const _hoisted_15 = { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }
const _hoisted_16 = { class: "odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }, "Screen Resolution", -1))
const _hoisted_18 = { class: "border border-gray-300 p-2 text-gray-900 dark:text-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.browserDetails.browser.name) + " " + _toDisplayString(_ctx.browserDetails.browser.version), 1)
        ]),
        _createElementVNode("tr", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.browserDetails.os.name) + " " + _toDisplayString(_ctx.browserDetails.os.version), 1)
        ]),
        _createElementVNode("tr", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.browserDetails.device.model) + " " + _toDisplayString(_ctx.browserDetails.device.type) + " " + _toDisplayString(_ctx.browserDetails.device.vendor), 1)
        ]),
        _createElementVNode("tr", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.browserDetails.ua), 1)
        ]),
        _createElementVNode("tr", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.screenResolution), 1)
        ])
      ])
    ])
  ]))
}